import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable } from 'rxjs';
import { RequestService } from '@services/https/request.service';
import { GET_UNREAD_NOTIFICATIONS_COUNT_ADMIN } from 'environments/api.path'

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private notificationCountSubject = new BehaviorSubject<number>(0);
  notificationCount$ = this.notificationCountSubject.asObservable();

  updateCount(value: number) {
    this.notificationCountSubject.next(value);
  }

  userId: any = null;
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  count: any;

  constructor(private _request: RequestService) {}

  refreshCount() {
    this._request.GET(`${GET_UNREAD_NOTIFICATIONS_COUNT_ADMIN}`, {})
      .subscribe((resp: any) => {
        this.notificationCountSubject.next(resp.data);
      });
  }
}
function asObservable() {
    throw new Error('Function not implemented.');
}

